import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

function LoginPage({ onLoginSuccess }) {
  const [loginUsername, setLoginUsername] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await axios.post('http://localhost:3000/api/login', {
        username: loginUsername,
        password: loginPassword,
      });

      if (response.status === 200) {
        console.log('Login bem-sucedido:', response.data);
        onLoginSuccess(); // Chame a função onLoginSuccess

        // Redirecionar o usuário para a página de seleção de dificuldade
        navigate('/question-list');
      } else {
        console.log('Login falhou:', response.data);
      }
    } catch (error) {
      console.error('Erro ao fazer login:', error);
    }
  };

  return (
    <div className='login-box'>
      <h1>Quiz <br/> Projeto águas: conheça seu rio</h1>
      <label>E-mail <span>*</span></label>
      <input
        type="text"
        placeholder="Informe seu e-mail"
        value={loginUsername}
        onChange={(e) => setLoginUsername(e.target.value)}
      />
      <label>Senha <span>*</span></label>
      <input
        type="password"
        placeholder="Senha"
        value={loginPassword}
        onChange={(e) => setLoginPassword(e.target.value)}
      />
      <button onClick={handleLogin}>Login</button>
    </div>
  );
}

export default LoginPage;
